module.exports = __webpack_public_path__ + "static/media/cam-off.60765bda.svg";